import { IM2MSlice } from "../../../store/slices/m2mSlice"

export type PaymentToolsM2M = {
  icon: string
  title: string
  subtitle: string
}

export const PAYMENT_TOOLS_CONFIG: {
  [key in IM2MSlice["paymentType"]]: PaymentToolsM2M
} = {
  sbp: {
    icon: "sbpBox",
    title: "Через СБП",
    subtitle: "Со счета в вашем банке",
  },
}
